import React, { FC } from 'react';

const PlusIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49992 0.0833435C2.50992 0.0833435 0.083252 2.51001 0.083252 5.50001C0.083252 8.49001 2.50992 10.9167 5.49992 10.9167C8.48992 10.9167 10.9166 8.49001 10.9166 5.50001C10.9166 2.51001 8.48992 0.0833435 5.49992 0.0833435ZM8.20825 6.04168H6.04159V8.20834H4.95825V6.04168H2.79159V4.95834H4.95825V2.79168H6.04159V4.95834H8.20825V6.04168Z"
        fill="#323232"
      />
    </svg>
  );
};

export default PlusIcon;
